import React from 'react'
import { useMutation } from 'react-query'
import hooks from '../../../hooks'

const useReflectionPromptMutation = ({
    userId,
    promptId,
    content: inputContent,
    onSuccess = () => {}
}) => {
    const [content, setContent] = React.useState(inputContent || '')
    const cacheKeys = hooks.useCacheKeys()
    const { clearCache } = hooks.useCache({ key: cacheKeys.USER_REFLECTIONS, onReload: onSuccess })
    const { api, endpoints, url } = hooks.useApi()
    const { toastSuccess, toastError } = hooks.useToasts({ onSuccess: clearCache })

    const [ saveReflection, { isLoading: isUpdating }] = useMutation(
        () => api.post(url(endpoints.userReflection, { promptId, userId }), { content }),
        {
            onSuccess: () => toastSuccess('Reflection saved!'),
            onError: toastError
        }
    )

    return {
        isSavingReflection: isUpdating,
        content,
        setContent,
        saveReflection
    }
}

export default useReflectionPromptMutation
